import {h, render} from 'preact';

function FilterSideBar({facets, onChange}) {
    return (
        <div className="mSearchBar__Toggler">
            <div id="SearchSideBar" className="mSearchSideBar">
                <a className="mSearchSideBar__Toggler mNavigationToggler" href="#"
                   id="SearchSideBarToggler" data-component="NavigationToggler"
                    data-label-show="Afficher les filtres"
                    data-label-hide="Fermer"
                    data-toggle-class="SearchSideBar__Visible"
                    data-target-navigation="SearchSideBar">
                    <svg className="mNavigationToggler__Icon open" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 34.4 34.4" style="enable-background:new 0 0 34.4 34.4;">
                        <path fill="#323232" d="M34.4,16.5H19L29.9,5.6l-1.1-1.1L18,15.4V0h-1.5v15.4L5.6,4.5L4.5,5.6l10.9,10.9H0V18h15.4L4.5,28.9l1.1,1.1L16.5,19v15.4H18V19l10.9,10.9l1.1-1.1L19,18h15.4V16.5z"></path>
                    </svg>
                    <svg className="mNavigationToggler__Icon close" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 34.4 34.4" style="enable-background:new 0 0 34.4 34.4;">
                        <path fill="#323232" d="M34.4,16.5H19L29.9,5.6l-1.1-1.1L18,15.4V0h-1.5v15.4L5.6,4.5L4.5,5.6l10.9,10.9H0V18h15.4L4.5,28.9l1.1,1.1L16.5,19v15.4H18V19l10.9,10.9l1.1-1.1L19,18h15.4V16.5z"></path>
                    </svg>
                    <span className="mNavigationToggler__Label"></span>
                    <span className="mSearchBar__Toggler__Label">Sélection</span>
                </a>
                <div className="mSearchSideBar__Wrapper">
                    <div className="mSearchSideBar__Top">
                        Filtres des contenus
                    </div>
                    <div className="mSearchSideBar__Main">
                        <fieldset className="mSearchSideBar__Facets__Type" onChange={onChange}>
                        {Array.isArray(facets.type) &&
                        <ul className="mSearchSideBar__Facets">
                            {facets.type.map(({key, title, count, selected}) => (
                                <li className="mSearchSideBar__FacetItem">
                                    <input id={'item.type.' + key} type="radio" name="typeFilter" checked={selected} value={key} />
                                    <label htmlFor={'item.type.' + key} className="mSearchSideBar__FacetItem__Label">{title} <span className="count">({count})</span></label>
                                </li>
                            ))}
                        </ul>}
                        </fieldset>
                        <fieldset className="mSearchSideBar__Facets__Viewed" onChange={onChange}>
                            {Array.isArray(facets.viewed) &&
                            <ul className="mSearchSideBar__Facets">
                                {facets.viewed.map(({key, title, count, selected}) => (
                                    <li className="mSearchSideBar__FacetItem">
                                        <input id={'item.viewed.' + key} type="radio" name="viewedFilter" checked={selected} value={':' + key} />
                                        <label htmlFor={'item.viewed.' + key} className="mSearchSideBar__FacetItem__Label">{title} <span className="count">({count})</span></label>
                                    </li>
                                ))}
                            </ul>}
                        </fieldset>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FilterSideBar
